import React from "react";

const WorksCard = (props) => {
  // Props with the work information
  const { company, jobTitle, city, startYear, endYear } = props.work;
  return (
    <>
      <h3 className="text-[12px] text-dark_secondary">{company}</h3>
      <h4 className="text-[12px] font-Poppins text-dark_secondary">
        {jobTitle}
      </h4>
      <div className="flex justify-between">
        <span className="font-Poppins font-semibold text-[12px] text-gray">
          {city}
        </span>

        <span className="font-Poppins font-semibold text-[12px] text-gray">{`${startYear} - ${endYear}`}</span>
      </div>
    </>
  );
};

export default WorksCard;
